const ArrowUp = () => (
  <>
    <path
      fill="currentColor"
      d="M11.5 6.921 6.062 12.36a.48.48 0 0 1-.708-.006A.52.52 0 0 1 5.19 12a.49.49 0 0 1 .163-.354l6.08-6.08a.8.8 0 0 1 .268-.184.8.8 0 0 1 .298-.053q.162 0 .298.053.136.052.268.183l6.08 6.081a.5.5 0 0 1 .15.341.48.48 0 0 1-.15.367.5.5 0 0 1-.357.165.5.5 0 0 1-.356-.165L12.5 6.92V18.5a.48.48 0 0 1-.143.357A.48.48 0 0 1 12 19a.48.48 0 0 1-.357-.143.48.48 0 0 1-.143-.357z"
    />
  </>
)
export default ArrowUp
